'use strict';

goog.provide('Ntry.SoundSystem');

goog.require('Ntry.Utils');
goog.require('Ntry.STATIC');

Ntry.SoundSystem = function() {
    this.soundPath = '/legacy_media/ntry/';

    this.initSoundJS();

    Ntry.addEventListener('unitAction', this, this.playUnitSound);
    Ntry.addEventListener('itemFire', this, this.playItemSound);
    Ntry.addEventListener('playSound', this, this.playNormalSound);
    Ntry.addEventListener('run', this, this.bgmStart);
    Ntry.addEventListener('stop', this, this.bgmEnd);
    Ntry.addEventListener('complete', this, this.bgmEnd);
};

(function(p) {
    p.loadConfig = function() {
        const stageId = Number(Ntry.configManager.getConfig('stageId'));
        const player = Ntry.configManager.getConfig('playerType');

        if (player == 'CpartyCar' || stageId <= 20) {
            this.addSounds([
                { event: 'unitAction', name: 'maze_walk', eventType: Ntry.STATIC.WALK },
                { event: 'unitAction', name: 'maze_simoorook', eventType: Ntry.STATIC.SIMOOROOK },
                { event: 'unitAction', name: 'maze_jump', eventType: Ntry.STATIC.JUMP },
                { event: 'unitAction', name: 'maze_wall', eventType: Ntry.STATIC.WALL_CRASH },
                { event: 'unitAction', name: 'maze_bee', eventType: Ntry.STATIC.BEE_ATTACK },
                {
                    event: 'unitAction',
                    name: 'maze_electric',
                    eventType: Ntry.STATIC.ELECTRIC_SHOCK,
                },
                { event: 'unitAction', name: 'maze_fall', eventType: Ntry.STATIC.SLIP },
                { event: 'itemFire', name: 'maze_dest', eventType: Ntry.STATIC.GOAL_ITEM },
                { name: 'maze_success', eventType: 'mazeSuccess' },
                { event: 'unitAction', name: 'jr_walk', eventType: Ntry.STATIC.WALK },
                { event: 'unitAction', name: 'jr_simoorook', eventType: Ntry.STATIC.SIMOOROOK },
                { event: 'unitAction', name: 'jr_wall', eventType: Ntry.STATIC.WALL_CRASH },
                { event: 'itemFire', name: 'jr_flower', eventType: Ntry.STATIC.JR_ITEM },
                {
                    event: 'unitAction',
                    name: 'maze_simoorook',
                    eventType: Ntry.STATIC.GO_SLOW_CRASH,
                },
            ]);
            if (player == 'juni' && stageId == 15) {
                this.addSound({
                    event: 'itemFire',
                    name: 'jr_complete',
                    eventType: Ntry.STATIC.GOAL_ITEM,
                });
            } else {
                this.addSound({
                    event: 'itemFire',
                    name: 'jr_meet',
                    eventType: Ntry.STATIC.GOAL_ITEM,
                });
            }
        } else if (stageId < 30) {
            this.addSounds([
                { event: 'itemFire', name: 'ai_success', eventType: Ntry.STATIC.AI_GOAL },
                { event: 'itemFire', name: 'ai_item_get', eventType: Ntry.STATIC.AI_ITEM },
                { event: 'itemFire', name: 'ai_meteo', eventType: Ntry.STATIC.AI_METEO },
                { name: 'ai_out', eventType: Ntry.STATIC.LOST },
                { name: 'ai_item_use', eventType: 'ai_use_item' },
                { name: 'ai_simoorook', eventType: 'ai_simoorook' },
            ]);

            this.addBgm({
                name: 'ai_move',
            });
        } else {
            this.addSounds([
                { event: 'itemFire', name: 'ai_success', eventType: Ntry.STATIC.AI_GOAL },
                { event: 'itemFire', name: 'ai_item_get', eventType: Ntry.STATIC.AI_ITEM },
                { event: 'itemFire', name: 'ai_success', eventType: Ntry.STATIC.AI_METEO },
                { name: 'ai_success', eventType: Ntry.STATIC.LOST },
                { name: 'ai_item_use', eventType: 'ai_use_item' },
                { name: 'ai_simoorook', eventType: 'ai_simoorook' },
            ]);

            this.addBgm({
                name: 'ai_move',
            });
        }
    };

    p.initSoundJS = function() {
        const path = '/legacy_media';
        createjs.Sound.registerPlugins([createjs.WebAudioPlugin, createjs.HTMLAudioPlugin]);
        this.soundQueue = new createjs.LoadQueue();
        this.soundQueue.installPlugin(createjs.Sound);

        this._loadAudio([`${path}/click.mp3`, `${path}/click.wav`, `${path}/click.ogg`], 'click');
        this._loadAudio(
            [`${path}/delete.mp3`, `${path}/delete.ogg`, `${path}/delete.wav`],
            'delete'
        );
        this._loadAudio([`${path}/click.mp3`], 'entryMagneting');
        this._loadAudio([`${path}/delete.mp3`], 'entryDelete');

        createjs.Sound.stop();
    };

    p._loadAudio = function(filenames, name) {
        if (!window.Audio || !filenames.length) {
            // No browser support for Audio.
            return;
        }

        for (let i = 0; i < filenames.length; i++) {
            const filename = filenames[i];
            //var path = Blockly.pathToBlockly + filename;
            //var id = filename.match(/\/([^.]+)./)[1];
            //createjs.Sound.registerSound(path, id, 4);
            this.soundQueue.loadFile({
                id: name,
                src: filename,
                type: createjs.LoadQueue.SOUND,
            });
            break;
        }
    };

    p.addSounds = function(sounds) {
        const self = this;
        sounds.map((sound) => {
            self.addSound(sound);
        });
    };

    p.addSound = function(sound) {
        const soundEvent = sound.event ? sound.event : 'playSound';
        this.initSound({
            name: sound.name,
            id: soundEvent + sound.eventType,
        });
    };

    p.initSound = function(sound) {
        const path = `${this.soundPath + sound.name}.mp3`;
        this.soundQueue.loadFile({
            id: sound.id,
            src: path,
            type: createjs.LoadQueue.SOUND,
        });
    };

    p.playSound = function(soundId) {
        createjs.Sound.play(soundId);
    };

    p.playNormalSound = function(soundId) {
        this.playSound(`playSound${soundId}`);
    };

    p.playUnitSound = function(actionType) {
        this.playSound(`unitAction${actionType}`);
    };

    p.playItemSound = function(actionType) {
        this.playSound(`itemFire${actionType}`);
    };

    p.bgmStart = function() {
        if (this.bgmId) {
            this.bgmInstance = createjs.Sound.play(this.bgmId, { loop: -1 });
        }
    };

    p.bgmEnd = function() {
        if (this.bgmInstance) {
            this.bgmInstance.stop();
        }
    };

    p.addBgm = function(sound) {
        this.initSound({
            name: sound.name,
            id: sound.name,
        });
        this.bgmId = sound.name;
    };
})(Ntry.SoundSystem.prototype);
